module.exports = __webpack_public_path__ + "img/h-page4-12.b5c0a20c.png";